export default __webpack_public_path__ + "static/media/bg-pattern-footer-mobile.9f048cf0.svg";